// extracted by mini-css-extract-plugin
export default {"label":"label__43zqp","input":"input__5IM45","icon":"icon__IeF6x","icon--selected":"icon--selected__k9rbU","icon--unselected":"icon--unselected__RcULJ"};